import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Index', // 首页
    component: () => import('@/views/index.vue'),
  }, {
    path: '/works',
    name: 'Works', // 案例
    component: () => import('@/views/works.vue'),
  }, {
    path: '/self',
    name: 'Self', // self案例
    component: () => import('@/views/self.vue'),
  }, {
    path: '/aboutUs',
    name: 'AboutUs', // 关于我们
    component: () => import('@/views/about-us.vue'),
  }, {
    path: '/contact',
    name: 'Contact', // 联系我们
    component: () => import('@/views/contact.vue'),
  }, {
    path: '/announce',
    name: 'Announce', // 招标公示
    component: () => import('@/views/announce.vue'),
  }, {
    path: '*',
    beforeEnter: (to, from, next) => {
      next('/');
    }
  }]
})